import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from '../assets/images/sa-logo.svg';
import { getBrowser } from '../modules/Helper';
import { lang } from '../lang';

class Navbar extends Component {
  constructor(props) {
    var devLan = lang.getInterfaceLanguage();
    var language = devLan.split('-');
    lang.setLanguage(language[0]);
    super(props);

    this.browser = getBrowser().name;

    this.appName = 'CHROME';
    this.btnURL = process.env.REACT_APP_DOWNLOAD_URL;

    if (this.browser === 'firefox') {
      this.appName = 'FIREFOX';
      this.btnURL = process.env.REACT_APP_DOWNLOAD_URL_FIREFOX;
    }
  }

  render() {
    return (
      <nav className="main-header">
        <div className="main-container -navbar">
          <div className="logo-section">
            <NavLink to="/">
              <img className="image" src={Logo} alt="search administrator logo" />
            </NavLink>
          </div>
          <ul className="navbar-list">
            <li className="item">
              <NavLink className="navbar-link" to="/eula">
                {lang.eula}
              </NavLink>
            </li>
            <li className="item">
              <NavLink className="navbar-link" to="/privacy-policy">
                {lang.pp}
              </NavLink>
            </li>
            <li className="item">
              <NavLink className="navbar-link" to="/support">
                {lang.support}
              </NavLink>
            </li>
            <li className="item">
              <NavLink className="navbar-link" to="/uninstall">
                {lang.uninstall}
              </NavLink>
            </li>
            <li className="item">
              <a className="primary-btn -navbar" href={this.btnURL} target="_blank">
                {lang.addto} {this.appName}
              </a>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}
export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js